import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectISPPackageSDL {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectISPPackageSDL = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectISPPackageSDL) => {
  const itemList = useStoreState((state) => state.isp.ispPackageInfoList);
  // const itemList = [
  //   {
  //     id: 'Fast',
  //     value: 'Fast'
  //   },
  //   {
  //     id: 'Ultra',
  //     value: 'Ultra'
  //   },
  // ];
  const itemListFetch = useStoreActions((state) => state.isp.fetchispPackageInfoList);
  // const itemFetch = useStoreActions((state) => state.common.itemFetch);

  if (itemList === null) {
    itemListFetch();
  }

  const onSelect = (id) => {
    if (itemList) {
      const val = itemList.find((item) => item.packageId === id);
      onChange(val?.packageId);
    }
  };




  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Package"
      filterOption={(input, option) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.packageId} value={type.packageId}>
            {type.packageName} : BDT {type.packagePrice}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching ISP Package</Option>
      )}
    </Select>
  );
};
